import { init, thumbnailDecorator } from "@nosto/preact"
import { Serp, Category, Autocomplete, History } from "./components"
import { defaultConfig } from "./config"

import "./styles/index.css"

init({
    ...window.nostoTemplatesConfig,
    serpComponent: Serp,
    historyComponent: History,
    autocompleteComponent: Autocomplete,
    categoryComponent: Category,
    inputCssSelector: "#search",
    contentCssSelector: "#content",
    formCssSelector: "#search-form",
    hitDecorators: [
        thumbnailDecorator({ size: "9" })
    ],
    
    serpUrlMapping: {
        query: "q",
        "products.filter": "filter",
        "products.page": "page",
        "products.sort": "sort"
    },
    // Comment to rendering on the same page instead of redirect page
    serpPath: '/search',

    // Comment to rendering on the same page instead of redirect page
    serpPathRedirect: true,
    serpQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "imageHash",
                "thumbUrl",
                "description",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                "alternateImageUrls",
                'customFields.key',
                'customFields.value',
                "skus.id",
                "skus.name",
                "skus.price"
            ],
            facets: ["*"],
            size: defaultConfig.serpSize,
            from: 0
        }
    },
    autocompleteQuery: {
        products: {
            fields: [
                "productId",
                "url",
                "name",
                "imageUrl",
                "thumbUrl",
                "brand",
                "availability",
                "price",
                "priceText",
                "listPrice",
                "ratingValue",
                "reviewCount",
                "skus.id",
                "skus.name",
                "skus.price"
            ],
            size: defaultConfig.autocompleteProductsSize
        }
        // keywords: {
            // fields: ["keyword", "_highlight.keyword"],
            // size: defaultConfig.autocompleteKeywordsSize,
            // facets: ["*"]
        // }
    },
    compressUrlParameters: true,
    fallback: true,
    // // Uncomment for Category Merchandising
    // categoryCssSelector: '#MainContent',
    //    categoryQuery() {
    //     return {
    //         name: 'serp',
    //         products: {
    //             categoryId: this.categoryId(),
    //             categoryPath: this.categoryPath(),
    //             size: defaultConfig.serpSize,
    //             from: 0,
    //         }
    //     }
    // },
    shopifyStoreSettings: window.shopifyStoreSettings
})
